import React, { PropTypes } from 'react';
import classNames from 'classnames';
import WatchPropTypes from 'common/PropTypes';
import Stamp from '@alias/Stamp';
import AnchorWithFlags from 'common/AnchorWithFlags';
import ResponsiveThumbnail from 'common/ResponsiveThumbnail';
import playable from '@alias/Playable';
import { BucketLayout, ContentStatus } from 'enums';
import { contentSubtitle } from '@alias/lib/format';

const FEATURED_IMAGE_WIDTHS = [640, 900, 1200];
const IMAGE_WIDTHS = [280, 640, 1200];

const collectionItemOneLayouts = [
    BucketLayout.DEFAULT,
    BucketLayout.DEFAULT_UNLIMITED,
    BucketLayout['feature-left'],
    BucketLayout['feature-right'],
    BucketLayout.TAPESTRY_LEFT, // NOTE: will be deprecated
    BucketLayout.TAPESTRY_RIGHT, // NOTE: will be deprecated
    BucketLayout.SixteenNine
];

const Tile = ({
    clickHandler,
    content,
    featured,
    playerHref,
    layoutType,
    isNavigable,
    userIsBlackedOut,
    selected,
    showLock,
    userLocation,
    tileClassNames
}) => {
    const { id, description, imageHref, name, score, status } = content;
    const formattedSubtitle = contentSubtitle(content);
    const isContentUpcoming = (status === ContentStatus.UPCOMING);
    const isContentLive = (status === ContentStatus.LIVE);
    const isContentClickable = !isNavigable;

    const tileClassName = classNames(tileClassNames, {
        collection_item: !isNavigable,
        'dtc-watch__item': isNavigable,
        'collection_item--one': (collectionItemOneLayouts.indexOf(layoutType) !== -1) && !featured,
        'collection_item--three': layoutType === BucketLayout.COLLECTION,
        'collection_item--featured': featured
    });

    const metaDataClass = classNames('collection_item_meta', 'icon-font-before', {
        'icon-lock-solid-before': showLock
    });

    const playButtonClass = classNames({
        'button-play button-play--video': isContentClickable,
        'button-play--live': (isContentClickable && isContentLive)
    });

    const activeClass = classNames('collection__link', {
        'collection__link--active': selected,
        'collection__link--upcoming': (!isContentClickable && isContentUpcoming)
    });

    // TODO: the "isNew" property doesn't actually exist yet
    const newStamp = content.isNew ? <div className="new">NEW</div> : '';
    const descriptionEl = (featured && description) ? <p className="collection_item_desc">{description}</p> : '';
    let href;
    let tileClickHandler;

    if (isContentClickable || isNavigable) {
        tileClickHandler = clickHandler;
        href = playerHref;
    }

    const subtitleEl = formattedSubtitle ? <span>{formattedSubtitle}</span> : null;
    const timeZone = userLocation && userLocation.timeZone;
    return isNavigable ? (
        <AnchorWithFlags
            data-route="false"
            data-id={id}
            data-score={score}
            className={tileClassName}
            href={href}
            onClick={tileClickHandler}
        >
            <div className="dtc-watch__item__content">
                <img className="dtc-watch__film__image" src={imageHref} alt={name} />
            </div>
        </AnchorWithFlags>
    ) : (
        <article onClick={tileClickHandler} className={tileClassName} data-id={id} data-score={score}>
            <AnchorWithFlags data-route="false" className={activeClass} href={href}>
                <figure className="collection_item_media">
                    {newStamp}
                    <div className="media-wrapper media-wrapper--16x9">
                        <ResponsiveThumbnail
                            src={imageHref}
                            srcSetWidths={featured ? FEATURED_IMAGE_WIDTHS : IMAGE_WIDTHS}
                            sizes={'33vw'}
                            alt={name}
                        />
                        <div className={playButtonClass} />
                        <Stamp timeZone={timeZone} content={content} userIsBlackedOut={userIsBlackedOut} isTile />
                    </div>
                    <figcaption>
                        <h1 className="collection_item_title">{name}</h1>
                        <div className={metaDataClass}>
                            <div className="collection_item_truncate">
                                {subtitleEl}
                            </div>
                        </div>
                        {descriptionEl}
                    </figcaption>
                </figure>
            </AnchorWithFlags>
        </article>
    );
};

Tile.propTypes = {
    clickHandler: PropTypes.func,
    content: WatchPropTypes.content,
    featured: PropTypes.bool,
    layoutType: PropTypes.string,
    isNavigable: PropTypes.bool,
    userIsBlackedOut: PropTypes.bool,
    playerHref: PropTypes.string,
    selected: PropTypes.bool,
    userLocation: PropTypes.object,
    showLock: PropTypes.bool,
    tileClassNames: PropTypes.string
};

export default playable(Tile);
export { Tile as BaseTile };



// WEBPACK FOOTER //
// ./app/common/page/buckets/Tile.js